import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/agendamento`;

export default class AgendamentoService{
	static async salvar(form) {
		return axios.post(URL_BASE + "/salvar", form);
	}
	static async verificaSeHaAlgumAgendamentoCriado(idUsuario) {
		return axios.get(URL_BASE + "/verificaSeHaAlgumAgendamentoCriado?idUsuario=" + idUsuario);
	}
	static async consultarPorUsuario(idUsuario) {
		return axios.get(URL_BASE + "/consultarPorUsuario/" + idUsuario);
	}
	static async consultarAgenda(periodo, dia) {
		return axios.get(URL_BASE + "/consultarAgenda?periodo=" + periodo + "&dia=" + dia);
	}
	static async consultar(pagina = 0, agendamentosPorPagina = 5) {
		return axios.get(URL_BASE + "/consultar?pagina=" + pagina + "&agendamentosPorPagina=" + agendamentosPorPagina);
	}
	static async cancelar(id = 0) {
		return axios.post(URL_BASE + "/cancelar/" + id);
	}
}



// WEBPACK FOOTER //
// ./src/service/AgendamentoService.js